import React from 'react';

const Info: React.FC = () => {
  return (
    <div style={{
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      minHeight: '100vh',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        lineHeight: '1.6'
      }}>
        <h1 style={{
          fontSize: '3rem',
          fontWeight: '700',
          marginBottom: '2rem',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Hack Interview Assistant
        </h1>
        
        <div style={{
          backgroundColor: '#2d2d2d',
          padding: '30px',
          borderRadius: '12px',
          marginBottom: '30px',
          border: '1px solid #404040'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            marginBottom: '1rem',
            color: '#4ade80'
          }}>
            What is this?
          </h2>
          <p style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>
            This is an AI-powered coding interview assistant that helps you prepare for technical interviews. 
            Simply upload a screenshot of a coding problem, and our AI will analyze it and provide you with:
          </p>
          <ul style={{ paddingLeft: '20px', color: '#cccccc' }}>
            <li>Problem type identification</li>
            <li>Step-by-step solution approach</li>
            <li>Java code implementation</li>
            <li>Test cases and complexity analysis</li>
            <li>Interview tips and follow-up questions</li>
          </ul>
        </div>

        <div style={{
          backgroundColor: '#2d2d2d',
          padding: '30px',
          borderRadius: '12px',
          marginBottom: '30px',
          border: '1px solid #404040'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            marginBottom: '1rem',
            color: '#fbbf24'
          }}>
            How to use
          </h2>
          <ol style={{ paddingLeft: '20px', color: '#cccccc' }}>
            <li style={{ marginBottom: '0.5rem' }}>Take a screenshot of your coding interview question</li>
            <li style={{ marginBottom: '0.5rem' }}>Upload it using the API endpoint with proper authentication</li>
            <li style={{ marginBottom: '0.5rem' }}>Get comprehensive analysis and solution from Claude 3.7 Sonnet</li>
            <li style={{ marginBottom: '0.5rem' }}>Use the structured response to ace your interview</li>
          </ol>
        </div>

        <div style={{
          backgroundColor: '#2d2d2d',
          padding: '30px',
          borderRadius: '12px',
          border: '1px solid #404040'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            marginBottom: '1rem',
            color: '#f87171'
          }}>
            Technical Details
          </h2>
          <div style={{ color: '#cccccc' }}>
            <p><strong>Backend:</strong> AWS CDK with Lambda, DynamoDB, S3, and Bedrock</p>
            <p><strong>AI Model:</strong> Claude 3.7 Sonnet via AWS Bedrock</p>
            <p><strong>Authentication:</strong> Custom token-based authentication</p>
            <p><strong>API Endpoint:</strong> https://api-hack.georgii.tech</p>
          </div>
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '40px',
          padding: '20px',
          backgroundColor: '#0f172a',
          borderRadius: '8px',
          border: '1px solid #334155'
        }}>
          <p style={{ color: '#94a3b8', margin: 0 }}>
            Built with ❤️ for technical interview preparation
          </p>
        </div>
      </div>
    </div>
  );
};

export default Info;
